import { RequestMessageHeader } from "@westpierstudio/core-module-oryx/services/comms/types/BaseTypes";
import { MultipliedWildsData, SpinGamePlayData } from "./gameevents/Spin";
import { VSSpinGamePlayData } from "./gameevents/VSSpin";
import { GameEvent, GameRequest } from "./ServerEvents";
import { FREE_ROUND } from "./gameevents/OpenGame";

type GamePlayData = SpinGamePlayData | VSSpinGamePlayData;
export type LastEventData = Required<Omit<BaseGameEventData<GamePlayData>, "roundId">>;

type LastEvent = {
    correlationSeqId: number,
    data: LastEventData,
    event: GameEvent,
    seqId: number
}

export type NetPosition = {
    bets: number,
    netProfit: number,
    wins: number
}

export type BaseGameEvent<TEvent, TData> = {
    header: RequestMessageHeader,
    body: {
        balance: number,
        balanceVersion: number,
        correlationSeqId: number,
        data: TData,
        elapsedTimeInMillis?: number
        event: TEvent,
        lastEvent?: LastEvent,
        netPosition?: NetPosition,
        lastRoundId?: string,
        seqId: number
    }
}

export type TriggeringAction = {
    payload: BetData,
    type: string
}

export type OpenGameFreeSpinsCounter = {
    freeSpinsCounter: {
        freeSpinsRemaining: number;
        freeSpinsTotal: number;
    }
}

export type BaseGameEventData<TGamePlayData> = {
    accumulatedCoinsWon: number,
    accumulatedJackpotsMoneyWon: number,
    accumulatedMoneyWon: number,
    balanceAfterBetData: {
        balanceAfterBet: number,
        balanceAfterBetVersion: number
    },
    betData: BetData,
    buyInId: number,
    finalPersistingState: FinalPersistingState,
    gameplay: TGamePlayData & OpenGameFreeSpinsCounter,
    isRoundFinished: boolean,
    nextActions?: GameRequest[]
    roundId: string,
    totalCoinsWon: number,
    totalMoneyWon: number,
    freeRounds?: FREE_ROUND,
    triggeringAction: TriggeringAction
}

export type BetData = {
    coinSize: number,
    coinsPerBet: number,
    pickIndex: number | null,
    playerBet: number
}

export enum ServerOverlayID {
    O = `O`,
    VS = `VS`,
    FG = `FG`,
    P1 = `P1`,
    P2 = `P2`,
    P3 = `P3`,
    P4 = `P4`,
    P5 = `P5`,
    P6 = `P6`,
}

export type SymbolID = "M1" | "M2" | "M3" | "M4" | "F5" | "F6" | "F7" | "F8" | "F9" | "WW";
export type ReelSymbols = [SymbolID, SymbolID, SymbolID, SymbolID];

export type JackpotID = "P1" | "P2" | "P3" | "P4" | "P5" | "P6";
export type OverlayID = "E" | ServerOverlayID;
export type OverlaySymbols = [OverlayID, OverlayID, OverlayID, OverlayID];

export const enum VSOption {
    DRAGON,
    PANDA
}

export const enum VSResult {
    DRAGON_WIN,
    PANDA_WIN,
    DRAW
}

export type OverlaySymbolData = {
    board: "DRAGONS_BOARD" | "PANDAS_BOARD",
    position: SymbolPos,
    type: ServerOverlayID
};

export type ReelSetSymbols = [
    ReelSymbols,
    ReelSymbols,
    ReelSymbols,
    ReelSymbols
];

export type ReelSetOverlays = [
    OverlaySymbols,
    OverlaySymbols,
    OverlaySymbols,
    OverlaySymbols
];

export type SymbolPos = {
    column: number,
    row: number
}

export type MultipliedWinsMap = {[paylineWinArrayIndex: number]: {multiplier: number, multipliedCoinsWon: number, multipliedMoneyWon: number}}

export type PayLineWin = {
    coinsWon: number,
    moneyWon: number,
    oakIndex: number,
    pattern: SymbolPos[],
    paylineIndex: number,
    symbol: SymbolID
}

export type FreeSpinsCounter = {
    freeSpinsRemaining: number,
    freeSpinsTotal: number
}

export type TriggeringState = {
    bonusSymbolPositions: SymbolPos[],
    multipliedWinsMap: MultipliedWinsMap,
    paylineWins: PayLineWin[],
    reels: ReelSetSymbols
}

export type BonusTriggeringState = {
    freeGamesState?: BonusTriggeringState,
    dragonsReels: ReelSetSymbols,
    pandasReels: ReelSetSymbols,
    oldDragonsReels: ReelSetSymbols,
    oldPandasReels: ReelSetSymbols,
    overlaySymbols: OverlaySymbolData[],
    dragonsPaylineWins?: PayLineWin[],
    pandasPaylineWins?: PayLineWin[],
    dragonsMultipliedWins?: MultipliedWinsMap,
    pandasMultipliedWins?: MultipliedWinsMap,
    dragonsWilds?: MultipliedWildsData,
    pandasWilds?: MultipliedWildsData
}

export type FinalPersistingState = {
    gameHistory: {
        dragonsSideMoneyWon: number,
        pandasSideMoneyWon: number
    }[]
}
